/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        19/02/2020      805: SEND ME THIS INFORMATION
CHID-2     Usha        26/02/2020      2695: Send member details Page
**
*******************************************************************************/
import React, { Component } from "react";
import { Link, classnames as cx } from "@mna/react";
import Form from "@mna/react-ui/Form";
import i18next from "i18next";
import schema from "@mna/schema";
import moment from "moment/moment.js";
import { Trans } from "react-i18next";
import Switch from "react-switch";
import IconX from "../../../assets/icons/x.svg";
import { getDayData } from "@mna/calendar";
import SelectBirthDate from "../start/SelectBirthDate";
import SelectGender from "../start/SelectGender";
import SelectPregnancyStatus from "../start/SelectPregnancyStatus";
import SelectChildBirth from "../start/SelectChildBirth";
import getmonthname from "../start/GetMonth";
import {
  checkAndGetSessionStorageValue,
  getDate,
  check,
  getDateWithIso,
  generateJsonWebToken,
  translateContent,
  getAndSetTranslateVal,
  checkAndChangeContent,
} from "../../../features/utils";
import DatePicker from "rmc-date-picker";
import Modal from "@mna/react-ui/Modal";
import PhoneInput2 from "react-phone-input-2";
import { commonConstant } from "../../../server/triage/constants";
import IntlTelInput from 'react-intl-tel-input';

const formSchema = schema(({ string, stringOf }) => ({
  consent: stringOf("false"),
  mobile: string,
  email: string,
  effectTo: string,
  effectFrom: string,
  insurance: string,
  policyNum: string,
  username: string,
  height: string,
  weight: string,
  phone: string,
  phoneCheckbox: string,
  emailCheckbox: string,
  birthdate: string,
  gender: string,
  pregnant: string,
  childbirth: string,
  pregError: string,
  recentChildbirthError: string,
}));
var policyFromMinDate = getDateWithIso(new Date(), -1);
var getCurrentDate = getDateWithIso(new Date(), 0);
var policyToMinDate = getDateWithIso(new Date(), 0);
var policyToMaxDate = "";

var policyFromMinDateMobile = getDate(new Date(), -1);
var getCurrentDateMobile = getDate(new Date(), 0);
var policyToMinDateMobile = getDate(new Date(), 0);
var policyToMaxDateMobile = "";

const minDate = new Date(1900, 0, 1);
const maxDate = new Date(); // Born today!
const defaultDate = new Date(1960, 0, 1);

const updateMonthDay = (year, month, day) => {
  var updateMonth = month;
  var updateDay = day;
  if (updateMonth <= 9) {
    updateMonth = "0" + month;
  }
  if (updateDay <= 9) {
    updateDay = "0" + day;
  }
  return year + "-" + updateMonth + "-" + updateDay;
};

const { year, month, day } = getDayData(defaultDate);
var defaultFormattedDOB = updateMonthDay(year, month, day);
var travelDatesFrom = "";
var travelDatesTo = "";
var InsuredBirthday = "";
var phoneSelected = "";
var emailSelected = "";

function validateEmailField(str) {
  var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (!re.test(str)) {
    sessionStorage.setItem("EmailValidate", false);
    return false;
  }
  else {
    sessionStorage.setItem("EmailValidate", true);
    return true;
  }
}
function cancelRequestOnClick(state, history) {
  history.push(state.UserNavigatedToQT
    ? "/find-care-options/quick-telemedicine-screen"
    : state.isFacility || state.triageRequest.emergency || state.triageRequest.isFacilitySearch
      ? "/find-care-options/emergency"
      : state.isTravelAid2 && !state.triageRequest.isFacilitySearch && !state.triageRequest.isFacilitySearch
        ? "/find-care-options/location"
        : "/find-care-options/care-options"
  )
}
function errorMsgStyle() {
  // document.getElementById("childbirthError").style.display = "none";
  // document.getElementById("pregenecyError").style.display = "none";
  localStorage.setItem("pregenecyError", false);
  localStorage.setItem("childbirthError", false);
}

// function dateValidate(fields) {
//   let today = moment();
//   var birthdate = fields.dateofbirth;
//   let diff = today.diff(birthdate);
//   sessionStorage.setItem("dateToValidate1", false);
//   let dateToValidate = moment(birthdate, "YYYY/MM/DD", true);
//   if (!dateToValidate.isValid() || diff < 0) {
//     sessionStorage.setItem("dateToValidate1", false);
//   } else {
//     sessionStorage.setItem("dateToValidate1", dateToValidate.isValid());
//   }
// }
function dateValidate(fields) {
  let today = moment();
  let birthdate = fields.dateofbirth;

  let dateToValidate = moment(birthdate, "YYYY-MM-DD", true);
  sessionStorage.setItem("dateToValidate1", false);

  if (!dateToValidate.isValid()) {
    sessionStorage.setItem("dateToValidate1", false);
    return;
  }

  let age = today.diff(dateToValidate, "years");

  // Save DOB validation
  sessionStorage.setItem("dateToValidate1", true);

  // Set age in session (if needed later)
  sessionStorage.setItem("userAge", age);

  // HEIGHT & WEIGHT RULES
  if (age < 18) {
    sessionStorage.setItem("heightRequired", true);
    sessionStorage.setItem("weightRequired", true);
    if(fields.height === "")
      sessionStorage.setItem("heightValue", "");
    if(fields.weight === "")
      sessionStorage.setItem("weightValue", "");
  } else {
    sessionStorage.setItem("heightRequired", false);
    sessionStorage.setItem("weightRequired", false);
  }
}

async function onBlurCalled(setFields) {
  localStorage.removeItem("riskfactors");
  setFields({
    riskFactorVal: "",
    childBirthName: checkAndGetSessionStorageValue("isTravelAid2") !== "true" ? "" : "Recent childbirth",
    pregnant: "",
    selectChildBirth: "",
    selectRecentPhysicalInjury: "",
    isRiskFactorApiCompleted: false,
    isRiskFactorCompleted: false,
  });
}

function isFemaleAlreadyPregnant({ fieldProps, state }) {
  var isFemaleInPregnantStage;
  if (fieldProps.fields.dateofbirth == '') {
    isFemaleInPregnantStage = false;
    state.triageRequest.pregnant = "";
    state.triageRequest.childbirth = "";
    state.triageRequest.isFemaleInPregnantStage = isFemaleInPregnantStage;
    errorMsgStyle();
    return isFemaleInPregnantStage;
  } else {
    var dob = moment(
      fieldProps.fields.dateofbirth
    );
    var age = moment().diff(dob, "years");
    isFemaleInPregnantStage = age >= 13 && age < 60;
    if (!isFemaleInPregnantStage) {
      state.triageRequest.pregnant = "";
      state.triageRequest.selectChildBirth = "";
      sessionStorage.setItem("femaleError", false);
    }
    state.triageRequest.isFemaleInPregnantStage = isFemaleInPregnantStage;
    { sessionStorage.setItem("femaleError", true) }
    return isFemaleInPregnantStage;
  }
}

function isFemaleAlreadyPregnantValidation({ data }) {
  if (
    data.dateofbirth == ''
  ) {
    return false;
  } else {
    var dob = moment(data.dateofbirth);
    var age = moment().diff(dob, "years");
    if (data.gender == "F" && data.pregnant === '' && data.selectChildBirth === '') {
      // document.getElementById("childbirthError").style.display = "block";
      // document.getElementById("pregenecyError").style.display = "block";
      localStorage.setItem("pregenecyError", true);
      localStorage.setItem("childbirthError", true);
    }
    else if (data.gender == "F" && data.pregnant !== '') {
      // document.getElementById("pregenecyError").style.display = "none";
      localStorage.setItem("pregenecyError", false);
    } else if (data.gender == "F" && data.selectChildBirth !== '') {
      // document.getElementById("childbirthError").style.display = "none";
      localStorage.setItem("childbirthError", false);
    }
    if (data.gender == "F" && data.selectChildBirth === '') {
      // document.getElementById("childbirthError").style.display = "block";
      localStorage.setItem("childbirthError", true);
    } else if (data.gender == "F" && data.pregnant === '') {
      // document.getElementById("pregenecyError").style.display = "block";
      localStorage.setItem("pregenecyError", true);
    }
    else {
      errorMsgStyle();
    }
    if (age <= 13) {
      errorMsgStyle();
    }
    else if (age >= 60) {
      errorMsgStyle();
    }
    return age >= 13 && age < 60;

  }
}

export default class SendInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: true,
      phoneError: true,
      value: "",
      InsuranceDateFrom: false,
      InsuranceDateTo: false,
      InsuredDOB: false,
      phoneField: false,
      EmailField: false,
      birthdate: false,
      gender: false,
      pregnant: false,
      childbirth: false,
      validPhoneNumber: true,
      isValidPhoneNumber: false,
      countryChange: "",
    };
    this.onChange = this.onChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate() {
    var selectedFlag = document.getElementsByClassName("selected-flag")[0];
    if (selectedFlag) selectedFlag.setAttribute('aria-label', 'flag name');
    const itiFlagElement = document.querySelector('.iti-flag');
    if (itiFlagElement !== null) {
      const classList = itiFlagElement.classList;
      const classesArray = Array.from(classList);
      const index = classesArray.indexOf('iti-flag');
      if (index !== -1 && index + 1 < classesArray.length) {
        const countryShortCode = classesArray[index + 1];
        sessionStorage.setItem("countryShortCode", countryShortCode)
        var selectedFlagEl = document.getElementsByClassName("selected-flag")[0];
        var countryValue = selectedFlagEl ? selectedFlagEl.textContent : undefined;
        this.state.countryChange = countryValue;
      }
    }
  }
  handleChange(checked) {
    this.setState({ checked });
  }

  onChange(e) {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      this.setState({ value: e.target.value });
    }
  }

  openModel = () => {
    this.setState({
      showModal: true,
    });
  };

  closeModal = () =>
    this.setState({
      showModal: false,
    });

  openModelEffectTo = () => {
    this.setState({
      showModelEffectTo: true,
    });
  };

  closeModalEffectTo = () =>
    this.setState({
      showModelEffectTo: false,
    });

  openModelDOB = () => {
    this.setState({
      showModelDOB: true,
    });
  };

  closeModalDOB = () =>
    this.setState({
      showModelDOB: false,
    });

  genderError = (data, state) => {
    if (state !== undefined && state.gender === '') {
      errorMsgStyle();
    }
    else if (data !== undefined && data.gender === 'M' && sessionStorage.getItem("femaleError") === "true") {
      errorMsgStyle();
      sessionStorage.setItem("femaleError", true);
    }
    if (data.birthdate.month == "00") {
      errorMsgStyle();
    }
  }

  phoneCheckBox = () => {
    var check = document.getElementsByName("checkPhone");
    if (check[0].checked) {
      phoneSelected = document.getElementById("checkbox-phone").value;
      this.setState({ phoneField: true });
      sessionStorage.setItem("phoneField", true);
    } else {
      phoneSelected = "";
      this.setState({ phoneField: false });
      sessionStorage.setItem("phoneField", false);
    }
  };

  emailCheckBox = () => {
    const { state } = this.props;
    const { triageRequest } = state;
    var check = document.getElementsByName("checkEmail");
    if (check[0].checked) {
      emailSelected = document.getElementById("checkbox-email").value;
      this.setState({ EmailField: true });
      sessionStorage.setItem("EmailField", true);
      validateEmailField(emailSelected);
    } else {
      emailSelected = "";
      this.setState({ EmailField: false });
      sessionStorage.setItem("EmailField", false);
      sessionStorage.setItem("EmailValidate", "true")
    }
  };

  render() {
    const {
      state,
      actions,
      history,
      setState,
      previousStepName,
      nextStepName,
    } = this.props;
    const { triageRequest } = state;
    var phoneNumber = state.phone ? state.phone.trim() : undefined;
    var selectedCountry = triageRequest.data ? triageRequest.data.selectedCountry : undefined;
    const telemedicine = "Telemedicine";
    const conciergeCare = "Concierge Care";
    var dobMinDate = moment("1900-01-01").format("YYYY-MM-DD");
    var phoneInput = sessionStorage.getItem("phoneField");
    var emailInput = sessionStorage.getItem("EmailField");
    if (state.isTravelAid2 && !state.triageRequest.emergency && !state.triageRequest.isFacilitySearch) {
      state.triageRequest.activeMenu = "start";
    } else if (state.triageRequest.emergency || state.isFacility || state.triageRequest.isFacilitySearch) {
      state.triageRequest.activeMenu = "emergency";
    } else {
      state.triageRequest.activeMenu = "care-options";
    }
    return (
      <div className="content-width mt-3 contact-container">
        <h1 className="text-left standby-page-header-title">
          {state.isFacility || state.triageRequest.isFacilitySearch ?
            <Trans i18nKey="PreferredCommunicationMethod">
              Please choose your preferred method of communication below to receive the contact details of the provider you selected.
            </Trans>
            : state.isTravelAid2 && !state.triageRequest.isFacilitySearch ?
              <Trans i18nKey="findcareoption.Careoptions.telemedicine.preferredCommunicationText">
                Let's make sure we have the best ways for the doctor to get in contact with you.
              </Trans>
              : <Trans i18nKey="findcareoption.Careoptions.telemedicine.connectiondetails">
                Let's make sure we have the best ways to get in contact with you.
              </Trans>
          }
        </h1>
        <Form
          id="sendInformation"
          fields={state.triageRequest}
          className="send-info-scrollbar"
          onValidate={(data) => {
            const errors = {};
            const required = "REQUIRED";
            var scheme = formSchema(data);
            setState({
              isSendInfoPageValidationStarted: true,
            });

            if (scheme !== null) {
              if (state.isFacility || state.triageRequest.isFacilitySearch) {
                var validateEmail = validateEmailField(data.email);
                if (!validateEmail && emailInput === "true") {
                  if ((scheme.email === required && emailInput === "true") || sessionStorage.getItem("EmailValidate") === "false")
                    errors.email = required;
                }
              } else {
                if (scheme.email === required || sessionStorage.getItem("EmailValidate") === "false") errors.email = required;
              }
              if (state.phone === undefined) {
                state.phone = "";
              }
              if (state.phone != null) {
                const hasAlphabets = /[a-zA-Z]/.test(state.phone);
                const regex = /[!@#$%^&*(),.?+":{}|<>]/;
                const hasSpecialChars = regex.test(state.phone);
                if (phoneSelected != "") {
                  if (hasSpecialChars || hasAlphabets || !state.validPhoneNumber || state.phone === "") {
                    this.setState({ validPhoneNumber: false })
                    errors.phone = required;
                  }
                }
                else {
                  if (!state.isFacility && !state.triageRequest.isFacilitySearch) {
                    if (state.phone.length <= 4 || !state.validPhoneNumber || hasSpecialChars || hasAlphabets) {
                      this.setState({ validPhoneNumber: false })
                      document.getElementById("errorPhone").style.display = 'block';
                      errors.phone = required;
                    }
                  }
                }
              }
              if (!state.isFacility && !state.triageRequest.isFacilitySearch) {
                if (!state.triageRequest.emergency && state.isTravelAid2 && isFemaleAlreadyPregnantValidation({ data })) {
                  if (localStorage.getItem("pregenecyError") === "true" && localStorage.getItem("childbirthError") === "true") {
                    if (data.pregnant !== '' && data.selectChildBirth !== '') {
                      errorMsgStyle();
                    } else {
                      errors.pregnant = required;
                      errors.selectChildBirth = required;
                    }
                  } else if (localStorage.getItem("childbirthError") === "true") {
                    errors.selectChildBirth = required;
                  } else if (localStorage.getItem("pregenecyError") === "true") {
                    errors.pregnant = required;
                  }
                }
                if (scheme.username === required) errors.username = required;
                let hrequired = sessionStorage.getItem("heightRequired") === "true";
                let hHasValue = sessionStorage.getItem("heightValue") === "";
                if ((scheme.height === required || scheme.height === undefined) && hrequired && hHasValue) errors.height = required;
                let wrequired = sessionStorage.getItem("weightRequired") === "true";
                let wHasValue = sessionStorage.getItem("weightValue") === "";
                if ((scheme.weight === required || scheme.weight === undefined) && wrequired && wHasValue) errors.weight = required;
                if (
                  data.effectFrom === undefined || data.effectFrom === ''
                ) {
                  errors.effectFrom = required;
                }
                if (
                  data.effectTo === undefined || data.effectTo === ''
                ) {
                  errors.effectTo = required;
                }
                if (scheme.insurance === required) errors.insurance = required;
                if (scheme.policyNum === required) errors.policyNum = required;

                if ((state.isTravelAid2 || state.triageRequest.isFacilitySearch) && !state.triageRequest.emergency) {
                  if (data.dateofbirth === undefined || data.dateofbirth === "") errors.birthdate = required;
                  if (scheme.gender === required) {
                    errors.gender = required;
                    // document.getElementById("genderValidation").style.display = "block";
                  } else {
                    // document.getElementById("genderValidation").style.display = "none";
                  }

                  if (data.birthdate.month.toString().length === 1)
                    data.birthdate.month = "0" + data.birthdate.month;
                  if (data.birthdate.day.toString().length === 1)
                    data.birthdate.day = "0" + data.birthdate.day;
                  let today = moment();
                  let birthdate =
                    data.dateofbirth;
                  state.triageRequest.dateofbirth = birthdate;
                  let diff = today.diff(birthdate);
                  let dateToValidate = moment(birthdate, "YYYY/MM/DD", true);
                  sessionStorage.setItem("dateToValidate", dateToValidate.isValid());

                  if (!dateToValidate.isValid() || diff < 0) {
                    //errors.birthdate = required;
                  }
                  else if (data.gender === "") {
                    errors.gender = required;
                  }
                  else {
                    if (
                      data.gender &&
                      data.gender === "F" &&
                      isFemaleAlreadyPregnantValidation({ data })
                    ) {
                      if (state.triageRequest.gender === "F" && data.gender === "F") {

                        if (scheme.childbirth === required && data.selectChildBirth == "") errors.selectChildBirth = required;
                        if (scheme.pregnant === required) errors.pregnant = required;
                      }
                      if (data.pregnant === "" && data.selectChildBirth == '' || data.selectChildBirth == undefined) {
                        localStorage.setItem("pregenecyError", true);
                        localStorage.setItem("childbirthError", true);
                        errors.pregnant = required;
                        errors.selectChildBirth = required;
                      }
                      else {
                        errorMsgStyle();
                      }
                      if (data.pregnant === "") {
                        localStorage.setItem("pregenecyError", true);
                        errors.pregnant = required;
                      }
                      else {
                        localStorage.setItem("pregenecyError", false);
                      }
                      if (data.childbirth === "" || data.childBirthName === undefined) {
                        localStorage.setItem("childbirthError", true);
                        errors.selectChildBirth = required;
                      }
                      else {
                        localStorage.setItem("childbirthError", false);
                      }
                      if (data.selectChildBirth == '' || data.selectChildBirth == undefined) {
                        if (scheme.childbirth === required) {
                          localStorage.setItem("childbirthError", true);
                          errors.selectChildBirth = required;
                        }
                        else {
                          localStorage.setItem("childbirthError", false);
                        }
                      }
                    }
                  }
                }
              }
              if (Object.keys(errors).length) return errors;
            }
          }}
          onSubmit={async (data) => {
            setState({
              isSendInfoPageValidationStarted: false,
            });
            console.log("data in si", data);
            state.triageRequest.height = data.Height;
            state.triageRequest.weight = data.Weight;
            sessionStorage.setItem("femaleError", false);
            if (state.isFacility || state.triageRequest.isFacilitySearch) {
              const { sessionId } = state.triageRequest;
              var jwtAccess_Token = generateJsonWebToken();
              var access_Token = checkAndGetSessionStorageValue("accessToken");
              async function translateAndGetAddress(area, country) {
                var translateArray = [{ text: area, }, { text: country, },];
                var translatedContent = await translateContent(
                  translateArray,
                  "en"
                );
                var listOfTranslatedArr = translatedContent.response.results;
                var tempAdminLevel = await getAndSetTranslateVal(
                  listOfTranslatedArr,
                  0,
                  area
                );
                var tempCountry = await getAndSetTranslateVal(
                  listOfTranslatedArr,
                  1,
                  country
                );
                tempCountry = checkAndChangeContent(
                  tempCountry,
                  commonConstant.USA
                );
                var localAdminLevel = "";
                var localCountry = "";
                if (tempAdminLevel) {
                  localAdminLevel = tempAdminLevel + ",";
                }
                if (tempCountry) {
                  localCountry = tempCountry;
                }
                var tempAddress = localAdminLevel + localCountry;
                return tempAddress;
              }
              var tempAddress = await translateAndGetAddress(
                state.triageRequest.location.parts.administrative_area_level_1,
                state.triageRequest.location.parts.country
              );
              actions.setTriageServiceRequest(data);
              state.triageRequest.data = data;
              state.countryCode = this.state.countryChange;
              state.triageRequest.data.phone = (state.countryCode ? state.countryCode.trim() : "") + " " + state.phone;
              state.triageRequest.data.selectedCountry = sessionStorage.getItem("countryShortCode");
              if (emailSelected == "") {
                state.triageRequest.data.email = "";
              }
              if (phoneSelected == "") {
                state.triageRequest.data.phone = "";
              }
              actions.sendTriageRequest({
                action: "AddPatientDetails",
                data: {
                  identifier: sessionId,
                  token: localStorage.getItem("token"),
                  Phone: data.phone,
                  Mobile: data.phone,
                  Email: data.email,
                  Address: tempAddress,
                  IsPatient: true,
                  jwtAccessToken: jwtAccess_Token,
                  accessToken: access_Token,
                  userContact:
                    emailSelected != "" && phoneSelected != ""
                      ? phoneSelected + ", " + emailSelected
                      : phoneSelected != ""
                        ? phoneSelected
                        : emailSelected,
                },
              });
              history.push("/find-care-options/done");
            } else {
              const {
                gender,
                birthdate,
                pregnant,
                birthdateSelected,
                triageSymptom,
                selectChildBirth,
                childBirthName,
                childbirth
              } = data;
              actions.setTriageServiceRequest(data);
              state.triageRequest.data = data;
              state.countryCode = this.state.countryChange;
              state.triageRequest.data.phone = (state.countryCode ? state.countryCode.trim() : "") + " " + state.phone;
              state.triageRequest.data.selectedCountry = sessionStorage.getItem("countryShortCode");
              state.triageRequest.insuredInfo =
                data.insuredOn ||
                data.insuredBirthDate ||
                data.sex ||
                data.relation;
              state.triageRequest.checked = this.state.checked;
              actions.setTriageBio({
                gender,
                birthdate,
                pregnant,
                birthdateSelected,
                childBirthName,
                triageSymptom,
                selectChildBirth,
                childbirth
              });
              history.push("/find-care-options/patientdetails-confo-screen");
            }
          }}
        >
          {(fieldProps) => (
            <div>
              {state.isFacility || state.triageRequest.isFacilitySearch ? (
                <fieldset>
                  <div>
                    <div className="w-col pr-3 pl-0 w-col-6 w-col-tiny-tiny-stack">
                      <legend>
                        <h2>
                          <Trans i18nKey="Preferredcontact">
                            Preferred contact method
                          </Trans>
                        </h2>
                      </legend>
                    </div>
                    <div className="w-col pt-2-FindFacility w-col-3 w-col-tiny-tiny-stack">
                      <input
                        type="checkbox"
                        id="checkbox-phone"
                        name="checkPhone"
                        value="Phone"
                        onClick={this.phoneCheckBox}
                        defaultChecked={
                          state.triageRequest.data
                            ? state.triageRequest.data.checkPhone
                            : fieldProps.fields.phoneCheckbox
                        }
                        className="align"
                        aria-label={i18next.t("Preferredcontact") + " " + i18next.t("findcareoption.Careoptions.SMS(textMsg)")}
                      />
                      <label htmlFor="checkbox-phone" className="w-radio w-radio-textsize align w-radio-facility">
                        <Trans i18nKey="findcareoption.Careoptions.SMS(textMsg)">
                          SMS (Text msg)
                        </Trans>
                      </label>
                    </div>
                    <div className="w-col pt-2-FindFacility w-col-3 w-col-tiny-tiny-stack">
                      <input
                        type="checkbox"
                        id="checkbox-email"
                        name="checkEmail"
                        value="Email"
                        onClick={this.emailCheckBox}
                        defaultChecked={
                          state.triageRequest.data
                            ? state.triageRequest.data.checkEmail
                            : fieldProps.fields.emailCheckbox
                        }
                        aria-label={i18next.t("Preferredcontact") + " " + i18next.t("findcareoption.Careoptions.sendinfo.Email")}
                        className="align"
                      />
                      <label htmlFor="checkbox-email" className="w-radio w-radio-textsize align w-radio-facility">
                        <Trans i18nKey="findcareoption.Careoptions.sendinfo.Email">
                          Email
                        </Trans>
                      </label>
                    </div>
                    {phoneInput === "true" && (
                      <div className="pt-1 pb-2">
                        {/* <PhoneInput2
                          inputProps={{
                            name: "phone",
                          }}
                          id="txtPhone"
                          className="mt-4"
                          inputClass={cx(fieldProps.invalidFields.phone ? "is-error" : "")}
                          value={
                            state.triageRequest.data
                              ? state.triageRequest.data.phone
                              : fieldProps.fields.phone
                          }
                          placeholder={i18next.t(
                            "findcareoption.Careoptions.PhoneNumber"
                          )}
                          onChange={(phone) =>
                            this.setState({ phone, phoneError: true })
                          }
                          isValid={(value, country) => {
                            if (value.match(/12345/)) {
                              return (
                                "Invalid value: " + value + ", " + country.name
                              );
                            } else if (value.match(/1234/)) {
                              return false;
                            } else {
                              return true;
                            }
                          }}
                        /> */}
                        <IntlTelInput
                          containerClassName={`intl-tel-input ${this.state.isValidPhoneNumber ? 'valid' : 'invalid'}`}
                          inputClassName={`form-control ${this.state.validPhoneNumber ? '' : 'is-error'}`}
                          defaultValue={phoneNumber}
                          onPhoneNumberChange={(phone, value, countryData) =>
                            setState({ phone: value, phoneError: true, selectedCountry: countryData.iso2 })
                          }
                          defaultCountry={selectedCountry}
                          separateDialCode={true}
                          autoPlaceholder={true}
                          onPhoneNumberBlur={(e) => {
                            if (e) {
                              const hasAlphabets = /[a-zA-Z]/.test(state.phone);
                              const regex = /[!@#$%^&*(),.?+":{}|<>]/;
                              const hasSpecialChars = regex.test(state.phone);
                              if (hasAlphabets || hasSpecialChars) {
                                this.setState({ validPhoneNumber: false })
                                setState({ validPhoneNumber: false })
                              }
                              else {
                                this.setState({ validPhoneNumber: true })
                                setState({ validPhoneNumber: true })
                              }
                            }
                            else {
                              this.setState({ validPhoneNumber: false })
                              setState({ validPhoneNumber: false })
                              //document.getElementById("errorPhone").style.display = 'block';
                            }
                          }}
                        />
                      </div>
                    )}
                    {emailInput === "true" && (
                      <input
                        type="text"
                        name="email"
                        placeholder={i18next.t(
                          "findcareoption.Careoptions.Email"
                        )}
                        defaultValue={
                          state.triageRequest.data ?
                            state.triageRequest.data.email
                            : fieldProps.fields.email
                        }
                        onBlur={(e) => {
                          var validateEmail = validateEmailField(e.target.value);
                          if (validateEmail) {
                            e.target.classList.remove('is-error');
                          }
                          else {
                            e.target.classList.add('is-error');
                          }
                        }}
                        className={fieldProps.invalidFields.email ? "is-error" : ""}
                      />
                    )}

                  </div>
                </fieldset>
              ) : (
                <div>
                  <h5>
                    <Trans i18nKey="Aboutyou">About you:</Trans>
                  </h5>
                  <input
                    type="text"
                    name="username"
                    placeholder={i18next.t("findcareoption.Start.Name")}
                    className={cx(
                      fieldProps.invalidFields.username ? "is-error" : ""
                    )}
                    defaultValue={
                      state.triageRequest.data
                        ? state.triageRequest.data.username
                        : fieldProps.fields.username
                    }
                    onBlur={(e) => {
                      if (e.target.value !== '' && e.target.value.length > 0) {
                        e.target.className = '';
                        document.getElementById("errorUserName").style.display = 'none';
                      }
                      else {
                        e.target.className = 'is-error';
                        document.getElementById("errorUserName").style.display = 'block';
                      }
                    }
                    }
                  />
                  <div id="errorUserName" className="errormessage-phone"
                    style={fieldProps.invalidFields.username
                      ? { display: "block" }
                      : { display: "none" }
                    }>
                    {i18next.t("findcareoption.Start.errorMessages.userName")}
                  </div>

                  {state.isTravelAid2 && !state.triageRequest.emergency && !state.triageRequest.isFacilitySearch && (
                    <>
                      <input
                        id="dobField"
                        type="text"
                        name="dobField"
                        min={dobMinDate}
                        max={getCurrentDate}
                        defaultValue={state.triageRequest.data
                          ? state.triageRequest.data.dateofbirth
                          : fieldProps.fields.dateofbirth}
                        placeholder={i18next.t("findcareoption.Start.DOB")}
                        className={cx(
                          fieldProps.invalidFields.birthdate
                            ? "is-error w-input"
                            : "w-input"
                        )}
                        onChange={(e) => {
                          fieldProps.setFields({
                            dateofbirth: e.currentTarget.value,
                          });
                          check(e);

                        }}
                        onFocus={(e) => {
                          e.currentTarget.type = "date";
                        }}
                        onBlur={(e) => {
                          dateValidate(fieldProps.fields);
                          e.currentTarget.placeholder = "What's your birthdate?";
                          if (e.currentTarget.value === '') {
                            e.target.classList.add('is-error');
                            document.getElementById("errorDOB").style.display = "block";
                          } else {
                            onBlurCalled(fieldProps.setFields);
                            e.target.classList.remove('is-error');
                            document.getElementById("errorDOB").style.display = "none";
                          }

                        }}
                      />

                      <div id="errorDOB" className="errormessage-phone"
                        style={fieldProps.invalidFields && fieldProps.invalidFields.birthdate
                          ? { display: "block" }
                          : { display: "none" }
                        }>
                        {i18next.t("findcareoption.Start.errorMessages.errorDOB")}
                      </div>
                      {/* Sex assigned at birth? */}
                      <SelectGender
                        {...fieldProps}
                        state={state}
                        onClick={this.genderError(fieldProps.fields, state.triageRequest.data)}
                        actions={actions}
                        className={fieldProps.invalidFields.gender ? "is-error" : ""}
                      />
                      {fieldProps.fields.gender === "F" && fieldProps.fields.childBirthName &&
                        isFemaleAlreadyPregnant({ fieldProps, state }) ? (
                        <SelectPregnancyStatus actions={actions} state={state}  {...fieldProps} className={fieldProps.invalidFields.pregnant ? "is-error" : ""} />
                      ) : (
                        <></>
                      )}
                      {fieldProps.fields.gender == "F" && fieldProps.fields.childBirthName &&
                        isFemaleAlreadyPregnant({ fieldProps, state }) ? (
                        <SelectChildBirth state={state} actions={actions} {...fieldProps} className={fieldProps.invalidFields.childbirth ? "is-error" : ""} />
                      ) : (
                        <></>
                      )}
                      <div className="container-heightweight">

                        {/* HEIGHT COLUMN */}
                        <div className="hw-column">

                          <div className="hw-row">
                            <h5 className="hw-label">
                              <Trans i18nKey="findcareoption.Start.Height">Height</Trans>
                            </h5>

                            <input

                              type="number"

                              name="Height"

                              min="0"

                              className={cx(

                                fieldProps.invalidFields.height ? "is-error" : "",

                                "height-input"

                              )}

                              defaultValue={

                                state.triageRequest.data

                                  ? state.triageRequest.data.Height

                                  : fieldProps.fields.height

                              }
                              onBlur={(e) => {
                                let required = sessionStorage.getItem("heightRequired") === "true";
                                let value = e.target.value;
                                if (required && (!value || parseFloat(value) < 0)) {
                                  sessionStorage.setItem("heightValue", "");
                                  e.target.classList.add("is-error");
                                  document.getElementById("errorheight").style.display = "block";
                                  if (parseFloat(value) < 0) {
                                    e.target.value = "";
                                  }
                                } else {
                                  sessionStorage.setItem("heightValue", value);
                                  //sessionStorage.setItem("heightRequired", false);
                                  e.target.classList.remove("is-error");
                                  document.getElementById("errorheight").style.display = "none";
                                }
                              }}

                            />
                            <h5 className="hw-label">
                              cm
                            </h5>
                          </div>
                          <div id="errorheight" className="errormessage-phone"
                            style={fieldProps.invalidFields.height
                              ? { display: "block" }
                              : { display: "none" }
                            }>
                            {i18next.t("findcareoption.Start.errorMessages.Height")}
                          </div>
                        </div>
                        {/* WEIGHT COLUMN */}
                        <div className="hw-column">

                          {/* Label + Input in same row */}
                          <div className="hw-row">
                            <h5 className="hw-label">
                              <Trans i18nKey="findcareoption.Start.Weight">Weight</Trans>
                            </h5>

                            <input
                              type="number"
                              name="Weight"
                              min="0"
                              className={cx(
                                fieldProps.invalidFields.weight ? "is-error" : "",
                                "weight-input"
                              )}
                              defaultValue={
                                state.triageRequest.data
                                  ? state.triageRequest.data.Weight
                                  : fieldProps.fields.weight
                              }
                              onBlur={(e) => {
                                let required = sessionStorage.getItem("weightRequired") === "true";
                                let value = e.target.value;
                                if (required && (!value || parseFloat(value) < 0)) {
                                  sessionStorage.setItem("weightValue", "");
                                  e.target.classList.add("is-error");
                                  document.getElementById("errorweight").style.display = "block";
                                  if (parseFloat(value) < 0) {
                                    e.target.value = "";
                                  }
                                } else {
                                  sessionStorage.setItem("weightValue", value);
                                  //sessionStorage.setItem("weightRequired", false);
                                  e.target.classList.remove("is-error");
                                  document.getElementById("errorweight").style.display = "none";
                                }
                              }}
                            />
                            <h5 className="hw-label">
                              lbs
                            </h5>
                          </div>

                          {/* Show error ONLY when invalid */}
                          {/* {fieldProps.invalidFields.weight && (
                        <div className="hw-error">
                          {i18next.t("findcareoption.Start.errorMessages.Weight")}
                        </div>
                      )} */}
                          <div id="errorweight" className="errormessage-phone"
                            style={fieldProps.invalidFields.weight
                              ? { display: "block" }
                              : { display: "none" }
                            }>
                            {i18next.t("findcareoption.Start.errorMessages.Weight")}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="pt-1">
                    <h5>
                      <Trans i18nKey="findcareoption.Careoptions.PhoneNumber">Phone Number:</Trans>
                    </h5>
                    {/* <PhoneInput2
                      inputProps={{
                        name: "phone",
                      }}
                      id="txtPhone"

                      inputClass={cx(
                        fieldProps.invalidFields.phone ? "is-error" : ""
                      )}
                      value={
                        state.triageRequest.data
                          ? state.triageRequest.data.phone
                          : fieldProps.fields.phone
                      }
                      placeholder={i18next.t(
                        "findcareoption.Careoptions.PhoneNumber"
                      )}
                      onChange={(phone) =>
                        this.setState({ phone, phoneError: true })
                      }
                      onBlur={(e) => {
                        if (e.target.value !== '' && e.target.value.length > 0){
                          e.target.classList.remove('is-error');
                          document.getElementById("errorPhone").style.display = 'none';
                        }
                        else{
                          e.target.classList.add('is-error');
                          document.getElementById("errorPhone").style.display = 'block';
                        }
                      }}
                      isValid={(value, country) => {
                        if (value.match(/12345/)) {
                          return (
                            "Invalid value: " + value + ", " + country.name
                          );
                        } else if (value.match(/1234/)) {
                          return false;
                        } else {
                          return true;
                        }
                      }}
                    /> */}
                    <IntlTelInput
                      containerClassName={`intl-tel-input ${this.state.isValidPhoneNumber ? 'valid' : 'invalid'}`}
                      inputClassName={`form-control ${this.state.validPhoneNumber ? '' : 'is-error'}`}
                      defaultValue={phoneNumber}
                      onPhoneNumberChange={(phone, value, countryData) =>
                        setState({ phone: value, phoneError: true, selectedCountry: countryData.iso2, countryCode: countryData.dialCode })
                      }
                      defaultCountry={selectedCountry}
                      separateDialCode={true}
                      autoPlaceholder={true}
                      onPhoneNumberBlur={(e) => {
                        if (e) {
                          const hasAlphabets = /[a-zA-Z]/.test(state.phone);
                          const regex = /[!@#$%^&*(),.?+":{}|<>]/;
                          const hasSpecialChars = regex.test(state.phone);
                          if (hasAlphabets || hasSpecialChars) {
                            this.setState({ validPhoneNumber: false })
                            setState({ validPhoneNumber: false })
                            document.getElementById("errorPhone").style.display = 'block';
                          }
                          else {
                            this.setState({ validPhoneNumber: true })
                            setState({ validPhoneNumber: true })
                            document.getElementById("errorPhone").style.display = 'none';
                          }
                        }
                        else {
                          this.setState({ validPhoneNumber: false })
                          setState({ validPhoneNumber: false })
                          document.getElementById("errorPhone").style.display = 'block';
                        }
                      }}
                    />
                  </div>
                  <div id="errorPhone" className="errormessage-phone"
                    style={
                      fieldProps.invalidFields.phone || !this.state.validPhoneNumber
                        ? { display: "block" }
                        : { display: "none" }
                    }>{i18next.t("findcareoption.Start.errorMessages.phoneNumber")}
                  </div>
                  <div className="pt-1">
                    <h5>
                      <Trans i18nKey="findcareoption.Careoptions.Email">Email:</Trans>
                    </h5>
                    <input
                      type="text"
                      name="email"
                      placeholder={i18next.t("findcareoption.Careoptions.Email")}
                      defaultValue={
                        state.triageRequest.data
                          ? state.triageRequest.data.email
                          : fieldProps.fields.email
                      }
                      className={fieldProps.invalidFields.email ? "is-error" : ""}
                      onBlur={(e) => {
                        var validateEmail = validateEmailField(e.target.value);
                        if (validateEmail) {
                          e.target.classList.remove('is-error');
                          document.getElementById("errorEmail").style.display = 'none';
                        }
                        else {
                          e.target.classList.add('is-error');
                          document.getElementById("errorEmail").style.display = 'block';
                        }
                      }}
                    />
                  </div>
                  <div id="errorEmail" className="errormessage-phone"
                    style={
                      fieldProps.invalidFields.email
                        ? { display: "block" }
                        : { display: "none" }}>
                    {i18next.t("findcareoption.Start.errorMessages.email")}
                  </div>
                  <fieldset>
                    <div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center">
                      <div className="gender-label">
                        <legend>
                          <h5 className="standby-form-legend-text">
                            <Trans i18nKey="Preferredcontact">
                              Preferred contact method
                            </Trans>
                          </h5>
                        </legend>
                      </div>
                      <div className="radio-container">
                        <label htmlFor="rbPhone" className="male-label">
                          <input
                            id="rbPhone"
                            type="radio"
                            value="Phone"
                            aria-label={i18next.t("Preferredcontact") + " " + i18next.t("findcareoption.Careoptions.Phone")}
                            onChange={(e) => {
                              state.triageRequest.userContact = e.currentTarget.value;
                            }}
                            name="contact"
                            defaultChecked={state.triageRequest.data && state.triageRequest.data.contact === "Phone"
                              ? state.triageRequest.data.contact
                              : fieldProps.fields.contact === "Phone"}
                            pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
                            className="radio-male"
                          />
                          <span className="span-male">
                            <Trans i18nKey="findcareoption.Careoptions.Phone">
                              Phone
                            </Trans>
                          </span>
                        </label>
                        <label htmlFor="rbEmail" className="female-label">
                          <input
                            id="rbEmail"
                            type="radio"
                            value="Email"
                            aria-label={i18next.t("Preferredcontact") + " " + i18next.t("findcareoption.Careoptions.sendinfo.Email")}
                            onChange={(e) => {
                              state.triageRequest.userContact = e.currentTarget.value;
                            }}
                            name="contact"
                            defaultChecked={state.triageRequest.data && state.triageRequest.data.contact === "Email"
                              ? state.triageRequest.data.contact : fieldProps.fields.contact === "Email"}
                            pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
                            className="radio-female"
                          />
                          <span className="span-female">
                            <Trans i18nKey="findcareoption.Careoptions.sendinfo.Email">
                              Email
                            </Trans>
                          </span>
                        </label>
                      </div>
                    </div>
                  </fieldset>
                  <textarea
                    name="notes"
                    className="mt-2 contact-notes"
                    aria-label={i18next.t("findcareoption.Careoptions.notes")}
                    rows="4"
                    placeholder={i18next.t("findcareoption.Careoptions.notes")}
                    defaultValue={state.triageRequest.data && state.triageRequest.data.notes
                      ? state.triageRequest.data.notes : fieldProps.fields.notes}
                  ></textarea>
                  <h5>
                    <Trans i18nKey="userregistration.Insurance">
                      Insurance info:
                    </Trans>
                  </h5>

                  <input
                    id="insurance-input"
                    type="text"
                    name="insurance"
                    defaultValue={
                      state.triageRequest.data &&
                        state.triageRequest.data.insurance
                        ? state.triageRequest.data.insurance.trim()
                        : fieldProps.fields.insurance
                    }
                    className={cx(
                      fieldProps.invalidFields.insurance ? "is-error" : ""
                    )}
                    placeholder={i18next.t("userregistration.insurancecarrier")}
                    pattern="[A-Za-z0-9\s.]{0,}[\S]{1,}[\s]{0,}"
                    onBlur={(e) => {
                      if (e.target.value !== '' && e.target.value.length > 0) {
                        e.target.classList.remove('is-error');
                        document.getElementById("errorInsurance").style.display = "none"
                      }
                      else {
                        e.target.classList.add('is-error');
                        document.getElementById("errorInsurance").style.display = "block"
                      }
                    }}
                  />
                  <div id="errorInsurance" className="errormessage-phone"
                    style={
                      fieldProps.invalidFields.insurance
                        ? { display: "block" }
                        : { display: "none" }
                    }>{i18next.t("findcareoption.Start.errorMessages.insuranceCarrier")}</div>

                  <input
                    id="policyNumber"
                    type="text"
                    name="policyNum"
                    defaultValue={
                      state.triageRequest.data &&
                        state.triageRequest.data.policyNum
                        ? state.triageRequest.data.policyNum.trim()
                        : fieldProps.fields.policyNum
                    }
                    placeholder={i18next.t("userregistration.Policy")}
                    pattern="[A-Za-z0-9\s.]{0,}[\S]{1,}[\s]{0,}"
                    className={cx(
                      fieldProps.invalidFields.policyNum ? "is-error" : ""
                    )}
                    onBlur={(e) => {
                      if (e.target.value !== '' && e.target.value.length > 0) {
                        e.target.classList.remove('is-error');
                        document.getElementById("errorPolicy").style.display = "none"
                      } else {
                        e.target.classList.add('is-error');
                        document.getElementById("errorPolicy").style.display = "block"
                      }
                    }}
                  />
                  <div id="errorPolicy" className="errormessage-phone"
                    style={
                      fieldProps.invalidFields.policyNum
                        ? { display: "block" }
                        : { display: "none" }
                    }>{i18next.t("findcareoption.Start.errorMessages.policyNumber")}</div>

                  <div className="standby-info-survey-select-birthdate">
                    <div className="w-col pl-0 w-col-6 w-col-tiny-tiny-stack date-field-alignment ">
                      <input
                        id="date-effect"
                        type="text"
                        name="effectFrom"
                        min={policyFromMinDate}
                        max={getCurrentDate}
                        defaultValue={state.triageRequest.data
                          ? state.triageRequest.data.effectFrom
                          : fieldProps.fields.effectFrom}
                        placeholder={i18next.t(
                          "findcareoption.Start.travelDateFrom"
                        )}
                        className={cx(
                          fieldProps.invalidFields.effectFrom
                            ? "is-error w-input"
                            : "w-input"
                        )}
                        onChange={(e) => {
                          policyToMaxDate = getDateWithIso(
                            new Date(e.currentTarget.value),
                            1
                          );
                          fieldProps.setFields({
                            EffectFrom: e.currentTarget.value,
                          });
                          check(e);

                        }}
                        onFocus={(e) => {
                          e.currentTarget.type = "date";
                        }}
                        onBlur={(e) => {
                          e.currentTarget.placeholder =
                            "Travel Date From: (dd/mm/yyyy)";
                          if (e.currentTarget.value === '') {
                            e.target.classList.add('is-error');
                            document.getElementById("errorTravelFrom").style.display = "block";
                          } else {
                            e.target.classList.remove('is-error');
                            document.getElementById("errorTravelFrom").style.display = "none";
                          }

                        }}
                      />
                      <div id="errorTravelFrom" className="errormessage-phone"
                        style={
                          fieldProps.invalidFields.effectFrom
                            ? { display: "block" }
                            : { display: "none" }}>
                        {i18next.t("findcareoption.Start.errorMessages.travelFromDate")}
                      </div>

                    </div>
                    <div className="w-col pr-0 pl-0 w-col-6 w-col-tiny-tiny-stack">
                      <input
                        id="date-effectto"
                        type="text"
                        name="effectTo"
                        min={policyToMinDate}
                        max={policyToMaxDate}
                        defaultValue={state.triageRequest.data
                          ? state.triageRequest.data.effectTo
                          : fieldProps.fields.effectTo}
                        placeholder={i18next.t(
                          "findcareoption.Start.travelDateTo"
                        )}
                        className={cx(
                          fieldProps.invalidFields.effectTo
                            ? "is-error w-input"
                            : "w-input"
                        )}
                        onChange={(e) => {
                          fieldProps.setFields({
                            EffectTo: e.currentTarget.value,
                          });
                          check(e);
                        }}
                        onFocus={(e) => {
                          e.currentTarget.type = "date";
                        }}
                        onBlur={(e) => {
                          e.currentTarget.placeholder =
                            "Travel Date To: (dd/mm/yyyy)";
                          if (e.currentTarget.value === '') {
                            e.target.classList.add('is-error');
                            document.getElementById("errorTravelTo").style.display = "block";
                          } else {
                            e.target.classList.remove('is-error');
                            document.getElementById("errorTravelTo").style.display = "none";
                          }
                        }}
                      />
                      <div id="errorTravelTo" className="errormessage-phone"
                        style={
                          fieldProps.invalidFields.effectTo
                            ? { display: "block" }
                            : { display: "none" }
                        }>
                        {i18next.t("findcareoption.Start.errorMessages.travelToDate")}
                      </div>
                    </div>
                  </div>
                  <div className="w-col w-col-tiny-tiny-stack">
                    <div htmlFor="material-switch" className="column-2 w-col w-col-9 w-col-tiny-tiny-stack insured text-bold">
                      <h5 className="marginTopInsurance"><Trans i18nKey="userregistration.toggle-msg">
                        Are you the primary insured on the policy?
                      </Trans></h5>
                    </div>
                    <div className="column-2 w-col w-col-3 w-col-tiny-tiny-stack primary-policy">
                      <Switch
                        checked={this.state.checked}
                        onChange={this.handleChange}
                        onColor="#006fd6"
                        onHandleColor="#2693e6"
                        handleDiameter={30}
                        aria-label={i18next.t("userregistration.toggle-msg")}
                        checkedIcon={
                          <div className="Yes-toggle">
                            <Trans i18nKey="userregistration.toggle-yes">
                              Yes
                            </Trans>
                          </div>
                        }
                        uncheckedIcon={
                          <div className="No-Toggle">
                            <Trans i18nKey="userregistration.toggle-no">
                              No
                            </Trans>
                          </div>
                        }
                        className="react-switch"
                        id="material-switch"
                      />
                    </div>
                  </div>
                  {!this.state.checked ? (
                    <div>
                      <h5>
                        <Trans i18nKey="userregistration.primaryInsured">
                          About Primary Insured
                        </Trans>
                      </h5>
                      <input
                        type="text"
                        name="insuredOn"
                        placeholder={i18next.t("findcareoption.Start.Name")}
                        defaultValue={
                          state.triageRequest.data
                            ? state.triageRequest.data.insuredOn
                            : fieldProps.fields.name
                        }
                      />

                      <div className="w-col pr-3 pl-0 w-col-6 w-col-tiny-tiny-stack standby-info-survey-select-birthdate">
                        <input
                          type="text"
                          defaultValue={state.triageRequest.data && state.triageRequest.data.insuredBirthDate
                            ? state.triageRequest.data.insuredBirthDate : fieldProps.fields.insuredBirthDate}
                          max={getCurrentDate}
                          className="w-input"
                          onChange={(e) => {
                            state.triageRequest.InsuredBirthday =
                              getDateWithIso(
                                new Date(e.currentTarget.value),
                                0
                              );
                            check(e);
                          }}
                          placeholder={i18next.t("userregistration.user-DOB")}
                          name="insuredBirthDate"
                          pattern="\s{0,}\d{4}-\d{1,2}-\d{1,2}\s{0,}"
                          onFocus={(e) => {
                            e.currentTarget.type = "date";
                          }}
                          onBlur={(e) => {
                            e.currentTarget.placeholder = "DOB (yyyy-dd-mm)";
                          }}
                        />
                      </div>

                      <fieldset className="selectInsuranceGender">
                        <div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center">
                          <div className="radio-container">
                            <label className="male-label">
                              <input
                                id="gender-radio"
                                type="radio"
                                value="M"
                                aria-label={i18next.t("userregistration.radio-male")}
                                onChange={(e) => {
                                  state.triageRequest.userGenderPrimary =
                                    e.currentTarget.value;
                                }}
                                name="sex"
                                defaultChecked={state.triageRequest.data && state.triageRequest.data.sex === "M"
                                  ? state.triageRequest.data.sex : fieldProps.fields.sex === "Male"}
                                pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
                                className="radio-male"
                              />
                              <span className="span-male">
                                <Trans i18nKey="userregistration.radio-male">
                                  Male
                                </Trans>
                              </span>
                            </label>
                            <label className="female-label">
                              <input
                                id="gender-radio-1"
                                type="radio"
                                value="F"
                                aria-label={i18next.t("userregistration.radio-female")}
                                onChange={(e) => {
                                  state.triageRequest.userGenderPrimary =
                                    e.currentTarget.value;
                                }}
                                name="sex"
                                defaultChecked={state.triageRequest.data && state.triageRequest.data.sex === "F"
                                  ? state.triageRequest.data.sex : fieldProps.fields.sex === "Female"}
                                pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
                                className="radio-female"
                              />
                              <span className="span-female">
                                <Trans i18nKey="userregistration.radio-female">
                                  Female
                                </Trans>
                              </span>
                            </label>
                          </div>
                        </div>
                      </fieldset>
                      <div>
                        <select
                          id="RelationList"
                          name="relation"
                          aria-label={i18next.t(
                            "userregistration.step4_select.relation"
                          )}
                          defaultValue={state.triageRequest.data && state.triageRequest.data.relation
                            ? state.triageRequest.data.relation : fieldProps.fields.relation}
                        >
                          <option value="" disabled selected>
                            {i18next.t(
                              "userregistration.step4_select.relation"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.self"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.self")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.child"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.child")}{" "}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.employee"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.employee"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.father"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.father")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.mother"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.mother")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.brother"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.brother")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.sister"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.sister")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.fosterchild"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.fosterchild"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.grandfather"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.grandfather"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.grandmother"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.grandmother"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.grandsonorgranddaughter"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.grandsonorgranddaughter"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.lifepartner"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.lifepartner"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.nephew"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.nephew")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.niece"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.niece")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.husband"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.husband")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.wife"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.wife")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.sponsoreddependent"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.sponsoreddependent"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.stepson"
                            )}
                          >
                            {i18next.t("userregistration.step4_select.stepson")}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.stepdaughter"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.stepdaughter"
                            )}
                          </option>
                          <option
                            value={i18next.t(
                              "userregistration.step4_select.otherrelationship"
                            )}
                          >
                            {i18next.t(
                              "userregistration.step4_select.otherrelationship"
                            )}
                          </option>
                        </select>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
              <button
                type="submit"
                className={cx(
                  "button standby-button standby-button-gradient standby-button-full-width standby-button-gradient-green" /* : 'btn-screen-nav--disabled' */
                )}
              >
                <Trans i18nKey="findcareoption.Careoptions.Concierge.Next">
                  Next
                </Trans>
              </button>
              <div className="standby-page-header standby-page-header-center">
                <a
                  className="standby-button-back"
                  href="#"
                  onClick={(e) => {
                    cancelRequestOnClick(state, history)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Spacebar" || e.key === " " || e.key === "Enter") {
                      cancelRequestOnClick(state, history);
                    }
                  }}
                >
                  <div className="icon">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 1024 1024"
                    >
                      <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
                    </svg>
                  </div>
                  <Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">
                    Cancel Request
                  </Trans>
                </a>
              </div>
            </div>
          )}

        </Form >

      </div >
    );
  }
}
